import { theme } from '@approvalmax/theme';
import styled from 'styled-components';

export const Root = styled.div`
    --card-min-width: 408px;

    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(var(--card-min-width), 1fr));
    gap: 16px;

    // this cover edge-case when single child try to stretch to 1fr
    &:has(> :only-child) {
        grid-template-columns: 424px;
    }

    @media (max-width: ${theme.container.breakpoint.medium}) {
        --card-min-width: 380px;
    }

    @media (min-width: ${theme.container.breakpoint.large}) {
        --card-min-width: 424px;
    }
`;
